import React from 'react';
import { Button, Grid } from 'antd';
import { PauseOutlined, CheckOutlined, AudioOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

export default function RecordingBarActions({
  isPaused,
  isRecording,
  handlePause,
  handleResume,
  handleReview,
}) {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = screens.xs;

  return (
    <>
      {isPaused ? (
        <Button
          type="default"
          size="large"
          icon={ isMobile ? null : <AudioOutlined />}
          onClick={handleResume}
          disabled={false}
          style={{ minWidth: isMobile ? 100 : 120 }}
        >
          {t('recording_modal.resume')}
        </Button>
      ) : (
        <Button
          type="primary"
          size="large"
          icon={ isMobile ? null : <PauseOutlined />}
          onClick={handlePause}
          disabled={!isRecording}
          style={{ minWidth: isMobile ? 100 : 120 }}
        >
          {t('recording_modal.pause')}
        </Button>
      )}
      <Button
        type="primary"
        size="large"
        icon={ isMobile ? null : <CheckOutlined />}
        onClick={handleReview}
        disabled={!isPaused}
        style={{ minWidth: isMobile ? 100 : 120 }}
      >
        {t('recording_bar.review')}
      </Button>
    </>
  );
}
